import React,{Component} from 'react';

import PropTypes from 'prop-types';

import LeftZXListSty from './LeftZXList.module.css';



class LeftZXList extends Component{

    static defaultProps={
        BLN_MarginTopHeight:0,
        zxzxListData:[],
    }

    render(){

        let zxLis=null;
        zxLis=this.props.zxzxListData.map((item,index)=>{
            return (
                <li>
                    <div className={LeftZXListSty.zxzx_li_bgSty} style={{backgroundImage:`url(${item.cover_link})`}}></div>
                    <div className={LeftZXListSty.zxzx_li_titleDiv}>
                        <div className={LeftZXListSty.zxzx_li_titleSty}>{item.title}</div>
                    </div>
                </li>
            )
        });


        return(
            <div className={`${LeftZXListSty.latestNewsDiv} ${this.props.className}`} style={{marginTop:this.props.BLN_MarginTopHeight+'px'}}>
                <div className={LeftZXListSty.titleSty}>{this.props.leftZXTitle}</div>
                <ul>
                    {zxLis}
                </ul>
            </div>
        );
    }
}


LeftZXList.propTypes={
    className:PropTypes.string,
    leftZXTitle:PropTypes.string.isRequired,
    BLN_MarginTopHeight:PropTypes.number,
    zxzxListData:PropTypes.array.isRequired,
    // leftMenuData:PropTypes.array.isRequired,
}


export default LeftZXList;